<template>
    <div v-if="data" class="stl-hero" :class="{ bad: !isMatch }" style="margin-bottom: 12px;">
        <div>
            <div class="microcap" style="margin-bottom: 6px;">{{ title }} · 계량 대조</div>
            <div v-if="isGas" class="formula">
                전체 − 세대 = <em>{{ fmtUsage(diff) }} {{ unitText }}</em>
            </div>
            <div v-else class="formula">
                전체 − (세대 + 공용) = <em>{{ fmtUsage(diff) }} {{ unitText }}</em>
            </div>
        </div>
        <span class="sp"></span>
        <div class="desc">
            <template v-if="isGas">
                <template v-if="isMatch">전체 사용량과 세대 합산이 일치합니다.<br /></template>
                <template v-else>전체 사용량과 세대 합산에 차이가 있습니다. 정보성 안내이며 정산을 차단하지 않습니다.<br /></template>
                <span class="num dim">
                    {{ fmtUsage(data.masterUsageQty) }} − {{ fmtUsage(data.subUsageSumQty) }} = {{ fmtUsage(diff) }}
                </span>
            </template>
            <template v-else>
                <template v-if="isMatch">전체 사용량과 세대 합산 + 공용부가 일치합니다.<br /></template>
                <template v-else>전체 사용량과 세대 합산 + 공용부에 차이가 있습니다. 정보성 안내이며 정산을 차단하지 않습니다.<br /></template>
                <span class="num dim">
                    {{ fmtUsage(data.masterUsageQty) }} − ({{ fmtUsage(data.subUsageSumQty) }} + {{ fmtUsage(data.commonUsageQty) }}) = {{ fmtUsage(diff) }}
                </span>
            </template>
        </div>
        <span class="stl-chip" :class="isMatch ? 'ok' : 'warn'"><i class="dot"></i>{{ isMatch ? "일치" : "차이 있음" }}</span>
    </div>
</template>

<script>
import { fmtUsage, unitLabel } from "../utils/settlementFormat.js";

export default {
    name: "ReconcileHero",
    props: {
        title: { type: String, required: true },
        data: { type: Object, default: null },
    },
    computed: {
        isGas() {
            return this.data?.energySource === "Gas" || this.data?.usageUnit === "Nm3";
        },
        unitText() {
            return unitLabel(this.data?.usageUnit);
        },
        diff() {
            if (!this.data) return null;
            if (this.data.diff !== null && this.data.diff !== undefined) return Number(this.data.diff);
            if (this.isGas) {
                return Number(this.data.masterUsageQty || 0) - Number(this.data.subUsageSumQty || 0);
            }
            return (
                Number(this.data.masterUsageQty || 0) -
                (Number(this.data.subUsageSumQty || 0) + Number(this.data.commonUsageQty || 0))
            );
        },
        isMatch() {
            return this.diff !== null && Math.abs(this.diff) < 0.0001;
        },
    },
    methods: { fmtUsage },
};
</script>
